<template>
    <q-page>
        <div class="q-display-1">Ustawienia</div>

        Bla bla bla
    </q-page>
</template>

<script>
    export default {
        name: 'Settings'
    }
</script>